import { supabase } from "../lib/api";

export const updateUserLikedLinks = async (props: { newLikedLinks: number[] }) => {
  const { newLikedLinks } = props;

  return await supabase.auth.updateUser({
    data: { likedLinks: newLikedLinks },
  });
};
